"use client";

import type { ReactNode } from "react";
import {
  FiltersShell,
  SortSelect,
  type FilterGroup,
} from "@/components/sections/comparador/filters-v2";

const SORT_OPTIONS = [
  { value: "price_asc", label: "Precio más bajo" },
  { value: "price_desc", label: "Precio más alto" },
  { value: "discount_desc", label: "Mayor descuento" },
  { value: "popular", label: "Más populares" },
];

interface Props {
  groups: FilterGroup[];
  defaultSort: string;
  rightAd?: ReactNode;
  /** Slot hoisted above the filters in the desktop sidebar — used by
   *  /comparador/despensa to host the "¿Qué quieres comparar?" chips. */
  sidebarTop?: ReactNode;
  children: ReactNode;
}

export function PantryHubShell({ groups, defaultSort, rightAd, sidebarTop, children }: Props) {
  return (
    <FiltersShell
      groups={groups}
      sortControl={<SortSelect options={SORT_OPTIONS} defaultValue={defaultSort} />}
      rightAd={rightAd}
      sidebarTop={sidebarTop}
      searchPlaceholder="Buscar en despensa básica…"
    >
      {children}
    </FiltersShell>
  );
}
